import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getStoredUser } from '../../helpers/user-storage.util';
import { ModalComponent } from '../../shared/modal/modal.component';

@Component({
  selector: 'opt-out-dialog',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './opt-out-dialog.component.html',
  styleUrl: './opt-out-dialog.component.scss',
})
export class OptOutDialogComponent {
  _active: boolean = false;
  @Input() set active(value: boolean) {
    this._active = value;
    if (value) this.isSubmitting = false;
  }
  get active() { return this._active; }

  @Output() handleOptOut = new EventEmitter<any>();
  @Output() modalClosed = new EventEmitter<boolean>();

  user = getStoredUser();
  isSubmitting = false;

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.isSubmitting = true;
    // Re-read the cached user here rather than relying on the field initializer's
    // snapshot: this component is created once when Settings mounts and never
    // torn down, so `this.user` can be stale (and its `version` behind) by the
    // time the vendor confirms the opt-out.
    this.user = getStoredUser();
    this.handleOptOut.emit(this.user);
  }
}
